import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  PARAM_CATEGORIES_PATH,
  STATUS_TYPE_LIST,
} from "src/app/admin/constants/constants";
import { AbstractListController } from "../../common/abstract-list.component";
import { UsersService } from "src/app/services/users.service";
import { Users } from "src/app/models/users";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DrawerModule } from "primeng/drawer";
import { RouterModule } from "@angular/router";
import { TopNavComponent } from "src/app/top-nav/top-nav.component";
import { DataTableComponent } from "../../common/data-table/data-table.component";
import {
  RowAction,
  TableColumn,
  TableFilter,
} from "../../common/data-table/data-table.model";

@Component({
  standalone: true,
  selector: "app-manage-users",
  templateUrl: "./manage-users.component.html",
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    CardModule,
    DrawerModule,
    TopNavComponent,
    DataTableComponent,
  ],
})
export class ManageUsersComponent extends AbstractListController<Users, any> {
  title = "Users";
  productDialog = false;

  tableColumns: TableColumn[] = [
    { field: "id", header: "ID", width: "80px" },
    { field: "display_name", header: "Nome" },
    { field: "u_created_on", header: "Registrato", type: "date" },
    { field: "user_email", header: "Email" },
    {
      field: "account_type",
      header: "Tipo",
      type: "tag",
      value: (row) => row.account_type,
      tagMap: {},
    },
    {
      field: "is_active",
      header: "Attivo",
      type: "tag",
      tagMap: {
        1: { label: "active", severity: "success" },
        0: { label: "not active", severity: "danger" },
      },
    },
  ];

  tableFilters: TableFilter[] = [
    { field: "id", header: "ID", type: "string" },
    { field: "user_email", header: "Email", type: "string" },
    { field: "display_name", header: "Nome", type: "string" },
    {
      field: "is_active",
      header: "Attivo",
      type: "select",
      options: STATUS_TYPE_LIST,
    },
  ];

  rowActions: RowAction[] = [
    {
      icon: "pi pi-eye",
      tooltip: "Dettagli",
      styleClass: "p-button p-button-primary",
      event: "view",
    },
  ];

  editLink = (row: Users): any[] => ["/admin/users/edit", row.id];

  constructor(
    private usersService: UsersService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      usersService,
      confirmationService,
      router,
      route,
      PARAM_CATEGORIES_PATH,
    );
    this.useTableFilters = true;
  }

  onAction(e: { event: string; row: Users }): void {
    if (e.event === "view") {
      this.item = { ...e.row };
      this.productDialog = true;
    }
  }
}
